import { render, staticRenderFns } from "./TransactionTable.vue?vue&type=template&id=2b184f2b"
import script from "./TransactionTable.vue?vue&type=script&lang=ts"
export * from "./TransactionTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports